/**
 * Function to be used in Once context to notify segment about
 * a new identification on top of the current analytics context
 *
 * @param {Object} user
 */
export function identifyAnalyticsUser({
  deputyUUID,
  firstname,
  lastname,
  email,
  phone,
}) {
  window.analytics.identify(deputyUUID, {
    ...window.__APP__.analyticsContext.user,
    deputyUUID: deputyUUID,
    firstName: firstname,
    lastName: lastname,
    email: email,
    phone: phone,
    deputyEmailFlag: !!email.match(/@deputy.com/),
  });
}
